<app-lens [workItem]="workItem"></app-lens>
